import AlertDialog from "components/Dialog";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { InputField } from "../../../../components/InputField";
import { MyCheckbox } from "../../../../components/MyCheckbox";
import ReversalCheckBoxes from "./ReversalCheckBoxes";

const EditReversalTypes = ({
  type,
  edit,
  updateFunc,
  formik,
  addNew,
  createFunc,
  addPath,
  disable,
}) => {
  const { push } = useHistory();
  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleCancel = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();
      formik.resetForm();
    push({
      pathname: "/financial-setting/reversal-types/view",
    });
  };
  useEffect(() => {
    if (disable === false) {
      push({
        pathname: "/financial-setting/view",
      });
    }
  }, []);
  const cancelFunc = () => {
    setOpenDisableAlert(true);
  };
  return (
    <div className="edit-reversal" style={{ paddingLeft: "20px" }}>
       <div className="d-flex justify-content-end pr-15">
        <Link
          className="btn btn-outline-primary leftmenu-btn"
          onClick={() => setOpenDisableAlert(true)}
          style={{ minWidth: 80 }}
        >
          Cancel
        </Link>
        <Link
          className="btn btn-primary leftmenu-btn  font-weight-bold ml-5"
          to={addPath.replace("edit", "view")}
          onClick={
            edit === true ? updateFunc : addNew === true ? createFunc : ""
          }
          style={{ minWidth: 80 }}
        >
          Save
        </Link>
      </div>
      <div
        className="col-md-4 edit-reversal-input"
        style={{ marginLeft: "33px" }}
      >
        <InputField
          {...{
            formik,
            name: "reversal_types_input",
            placeholder:
              addNew === true ? "" : formik.values?.reversal_types_input,
          }}
          value={formik.values?.reversal_types_input}
          style={{ height: "48px" }}
        />
      </div>

      <div className="edit-reversal-ceckbox">
        <ReversalCheckBoxes edit={edit} formik={formik} addNew={addNew} />
      </div>
      <AlertDialog
        open={openDisableAlert}
        handleClose={handleCloseDialog}
        onDecline={() => {
          setOpenDisableAlert(false);
        }}
        onAccept={handleCancel}
        title={" Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
     
    </div>
  );
};

export default EditReversalTypes;
